import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tc } from 'utils/theme';

const StyledErrorMessage = styled.p`
  color: ${tc('errorMessage')};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.3px;
  padding: 0;
  margin: 5px 0 0 0;
`;

/**
 * Field specific error message
 * @param {string} error string of the error to show on the form field
 */
function FieldError({ error }) {
  if (error) {
    return <StyledErrorMessage>{error}</StyledErrorMessage>;
  }
  return null;
}

FieldError.propTypes = {
  error: PropTypes.string,
};

FieldError.defaultProps = {
  error: '',
};

export default FieldError;
